<div class="form-group mb-3" [formGroup]="parentForm()">
  <div class="select">
    @if (label()) {
      <label class="form-label" [for]="id()">{{ label() }}</label>
    }
    <select
      [id]="id()"
      class="form-control"
      [formControlName]="formControlProp() ?? null"
    >
      @if (emptyOption()) {
        <option value=""></option>
      }
      @for (item of items(); track item) {
        <ng-template
          [ngTemplateOutlet]="template() ?? null"
          [ngTemplateOutletContext]="{ item: item }"
        ></ng-template>
      }
    </select>
  </div>

  <div class="content mt-1">
    <ng-content></ng-content>
  </div>
</div>
